import { service } from "@server/client";
import type {
  ClearPromotionMutation,
  ClearPromotionMutationVariables,
} from "@server/gql/graphql";
import { clearPromotionMutation as removePromotionsFromCartMutation } from "@server/queries/cart";

export const removePromotionsFromCart = async (
  variables: ClearPromotionMutationVariables,
) => {
  try {
    const response = await service<
      ClearPromotionMutation,
      ClearPromotionMutationVariables
    >({
      query: removePromotionsFromCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in removePromotionsFromCart", error);
    throw error;
  }
};
